<template>
  <div class="profile">
    <!-- <h1>This is the Profile page</h1> -->

    <div class="myheaderbar">
      <h1>PROFIL</h1>
    </div>

    <section>
        <!-- <div class="block">
            <button class="button" @click="setup.activeStep = 0">Set Profile</button>
        </div> -->
        
        <div class="block">
          <b-switch v-model="showAsAdmin" @input="setup.activeStep = 0"> Show as Admin User </b-switch>
        </div>



        <b-steps v-model="setup.activeStep" :animated="setup.isAnimated" :has-navigation="setup.hasNavigation">
            
            <b-step-item label="Profile" :clickable="setup.isStepsClickable" :type="{'is-success': setup.isProfileSuccess}">
                <PersonalProfile/>
            </b-step-item>

            <b-step-item :visible="showAsAdmin" label="Account" :clickable="setup.isStepsClickable">
                <AccountProfile/>
            </b-step-item>


            <b-step-item :visible="showAsAdmin" label="Members" :clickable="setup.isStepsClickable" disabled>
                
                <MemberPanel/>
            </b-step-item>
        </b-steps>
    </section>

    <!-- <PersonalProfile/> -->
  
  </div>
</template>

<script>
  // import Login from "../../components/auth/Login";
  import AccountProfile from "@/components/main/profile/AccountProfile.vue"
  import PersonalProfile from "@/components/main/profile/PersonalProfile.vue"
  import MemberPanel from "@/components/main/profile/MemberPanel.vue"

  export default {
    components: {
        // Login
        AccountProfile,
        PersonalProfile,
        MemberPanel
      },
      data() {
        return  {
          showAsAdmin: true,
          setup: {
            activeStep: 0,
            showSocial: false,
            isAnimated: true,
            hasNavigation: true,
            isStepsClickable: true,
            isProfileSuccess: false
          }
          
          // profile: {
          //   name: "Johnson",
          //   firstname: "Tony",
          //   phone: "+2421 548 755",
          //   company: "Tony Servis",
          //   role: "Tony Boss",
          //   email: "tony@johnson.com",
          //   username: "tonyjohnson",
          //   password: "somesekret",
          //   description: "Owner",
          //   file: null
          // }
        }
      },
      // methods: {
        // saveProfile () {
        //   console.log(this.profile)
        //   // window.alert(JSON.stringify(this.profile))
        // }
      // }
      
      // computed: {
      //   ...mapGetters(['getProfile'])
      // }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
    .my-center-horizontal {
      display: block;
    }
</style>